import { render, staticRenderFns } from "./CardForemansNotes.vue?vue&type=template&id=7bf4f4e0&"
import script from "./CardForemansNotes.vue?vue&type=script&lang=js&"
export * from "./CardForemansNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports